import { Component, Inject, OnInit } from '@angular/core';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { LanguageServices } from 'src/app/services/LanguageServices';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { LanguageInterface } from '../translate-form.component';
import { StringUtils } from 'src/app/system-utils/utils/StringUtils';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ButtonList } from 'src/app/system-utils/actions-buttons/actions-buttons.component';


@Component({
  selector: 'app-translate-form-ai',
  standalone:false,
  templateUrl: './translate-form-ai.component.html',
  styleUrl: './translate-form-ai.component.scss'
})
export class TranslateFormAiComponent implements OnInit {


  items: any[] = [];
  languages: LanguageInterface[] = [];
  idList: {guid:string,id:string}[] = [];
  arrayList: {guid:string,[x: string]: any}[] = [];
  buttonList:ButtonList[] = [];
  formGroup: FormGroup = new FormGroup({
    // origem fixa em PTBR (campo desabilitado, como no comportamento original)
    origem: new FormControl<string>({value:'PTBR', disabled:true},Validators.required),
    destino: new FormControl<string>('',Validators.required),
  });
  canDelete  =true;

  get origemCol(): string {
    return this.formGroup.get('origem').value;
  }

  get destinoCol(): string {
    return this.formGroup.get('destino').value;
  }

  constructor(
    public dialogRef: NzModalRef<TranslateFormAiComponent>,
    @Inject(NZ_MODAL_DATA) public data: any,
    private snackBar:SnackbarService,
    private ls:LanguageServices,
  ) {

    this.items = data.items
    this.languages = data.languages;
    this.createDistinctItems();
  }
  ngOnInit(): void {

    this.buttonList.push({
      color:"primary",
      description:"save",
      //disabled: this.canDelete,
      action: ()=>{
          this.save();
      }
    },
    {
      color:"warn",
      description:"cancel",
      action: ()=>{
          this.dialogRef.close();
      }
    })
  }

  save() {
    if ( this.formGroup.valid ){
      this.createReturnObject();
      this.dialogRef.close(this.items);
    }
  }

  createReturnObject(){

    let languageFrom = this.formGroup.get("origem").value;
    let languageTo = this.formGroup.get("destino").value;

    this.items.forEach((item) => {
      let guid = this.idList.find(d=>d.id ==  item['INTERNALID']).guid;
      let trad = this.arrayList.find(d=>d.guid == guid);
      if (  trad['error'] == null &&
            trad['error'] == undefined &&
            trad['translated'] == true ){
        item[languageFrom] = trad[languageFrom];
        item[languageTo] = trad[languageTo];
      }
    });

  }

  changingTranslation(item:any){
    item['translating'] = false;
    item['translated'] = true;
    item['error'] = null;
  }

  createDistinctItems() {
    this.items.forEach((item) => {
      var language:any[]  = JSON.parse(item['LANGUAGE']);
      var internalID = item['INTERNALID'];
      let origem = this.formGroup.get("origem").value;
      let languageId = this.ls.languages.find(item=>item.col==origem).id;
      var origemText = language.find((item) => item.language == languageId)?.text;

      var guid = null;

      var indexText = this.arrayList.findIndex((d) => d[origem] == origemText);

      if (indexText != -1) {
        guid = this.arrayList[indexText].guid;
      }else {
        guid = StringUtils.UIDGerador();
        this.arrayList.push({guid:guid, [origem]: origemText});
      }
      this.idList.push({guid:guid, id: internalID});
    });

  }

  getCountIds(guid:string):number{
    return this.idList.filter((item) => item.guid == guid).length;
  }

  removeFile(guid:string){
    if ( this.canDelete ){
      if ( guid != null ){
        this.arrayList = this.arrayList.filter((i) => i.guid != guid);
        this.idList = this.idList.filter((i) => i.guid != guid);
      }
    }
  }

  async translateItens(){
      if ( this.formGroup.valid ){

        this.canDelete = false;
        let newArray  = this.arrayList.filter((item) => item['translated'] == null || item['translated'] == false );

        if ( newArray.length == 0 ){
          this.snackBar.showError("translate.error.notranslatefound");
          this.canDelete = true;
          //this.changeButtonSaveState();
          return;
        }

        for ( var item of newArray ){
          let languageFrom = this.formGroup.get("origem").value;
          let languageTo = this.formGroup.get("destino").value;
          let textToTranslate =  item[this.formGroup.get("origem").value];
          item['translating'] = true;
          item[languageTo] =  this.ls.instant("translate.ia.traslating")+ "...";
          try {
              await this.ls.getGoogleTranslationLanguages(textToTranslate,languageFrom,languageTo).then((data:any) => {
                  if ( data != null ){
                    let translationsGoogle = JSON.parse(data);
                    let translation = translationsGoogle['data']['translations'][0]['translatedText'];
                    item[languageTo] = translation;
                    item['translating'] = false;
                    item['translated'] = true;
                  }else{
                    item[languageTo] = 'Error: ' + this.ls.instant("translate.error.notfound");
                    item['translating'] = false;
                    item['error'] = 'Error: ' + this.ls.instant("translate.error.notfound");
                    item['translated'] = false;
                  }
              }).catch((error:any) => {
                  item['error'] = 'Error: ' + error;
                  item[languageTo] = 'Error: ' + error;
                  item['translating'] = false;
                  item['translated'] = false;
              });


          }catch (error) {
              item['error'] = 'Error: ' + error;
          }
        }

        this.canDelete = true;
        //this.changeButtonSaveState();
      }else{
        this.snackBar.showError("translate.error.empty");
        this.canDelete = true;
        //this.changeButtonSaveState();
      }

  }

  changeButtonSaveState(){
      this.buttonList[0].disabled = !this.canDelete;
  }

}
